"use client";

import { motion } from "framer-motion";

const ProblemBlock = () => {
  return (
    <section className="w-full bg-white py-28 sm:py-36 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto text-center">
        {/* Small label */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="inter-medium text-sm tracking-wide uppercase text-[#64748B] mb-6"
        >
          The problem
        </motion.p>

        {/* Main headline */}
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="judson-regular text-[42px] sm:text-[56px] md:text-[72px] leading-[1.05] text-[#0F172A] max-w-5xl mx-auto"
        >
          ‘The process creates chaos and the consumer{" "}
          <span className="text-[#94A3B8]">pays the price’</span>
        </motion.h2>

        {/* Divider */}
        <div className="h-px w-32 bg-[#E5E7EB] mx-auto my-14" />

        {/* Body copy */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto text-center">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="inter-regular text-lg leading-relaxed text-[#334155]"
          >
            Buying or selling a home should feel exciting. Instead, most people
            experience confusion, conflicting advice, and unnecessary stress.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="inter-regular text-lg leading-relaxed text-[#334155]"
          >
            Too many steps, too many people, and no clear place to go for trusted
            answers.
          </motion.p>
        </div>

        {/* Closing line */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-20 inter-semibold text-xl text-[#0F172A]"
        >
          AskLocal exists to change that.
        </motion.p>
      </div>
    </section>
  );
};

export default ProblemBlock;
